'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var Analytics = _interopDefault(require('../../global/analytics.js'));
var utils_js = require('../../helpers/utils.js');
var FormsAPI = _interopDefault(require('../forms-api.js'));

/* eslint-disable camelcase */
var GA_EVENTS = {
  success: {
    tracker: { eventCategory: 'SignUp', eventAction: 'success', eventLabel: 'three field', dimension1: 'Lead' }
  },
  error_shop_name: {
    tracker: { eventCategory: 'SignUp', eventAction: 'error', eventLabel: 'Bad shop_name' }
  },
  error_email: {
    tracker: { eventCategory: 'SignUp', eventAction: 'error', eventLabel: 'Bad email' }
  },
  error_password: {
    tracker: { eventCategory: 'SignUp', eventAction: 'error', eventLabel: 'Bad password' }
  },
  mailcheck: {
    tracker: { eventCategory: 'SignUp', eventAction: 'suggestion', eventLabel: 'Email suggestion' }
  },
  customEmail: {
    tracker: { eventCategory: 'SignUp', eventAction: 'Custom email' }
  }
};

var FUNNEL_DEFAULTS = {
  funnel: 'signup-funnel',
  version: 4
};

var HIDDEN_FIELDS = ['ref', 'source', 'signup_code', 'ssid'];

/* eslint-enable camelcase */

function SignupTracker(options) {
  var defaults = {
    gaEvents: GA_EVENTS
  };

  this.config = _Object$assign({}, defaults, options);
  this.trackHiddenFieldsOnce = utils_js.once(this.trackHiddenFields);

  this.setupFunnel();
}

SignupTracker.prototype.setupFunnel = function () {
  var navSignup = $('#MainNavSignupButton').get(0);
  var pageSignup = $('.js-open-signup').not('#MainNavSignupButton').get(0);

  this.instaFunnelTrackLink(navSignup, {
    step: 'get-started',
    depth: 1
  });

  this.instaFunnelTrackLink(pageSignup, {
    step: 'start-your-free-trial',
    depth: 1
  });
};

SignupTracker.prototype.instaFunnelTrackLink = function (el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof window.analytics === 'undefined') {
    return;
  }
  if (el === null || typeof el === 'undefined') {
    return;
  }

  window.analytics.trackLink(el, 'insta_funnel', _Object$assign(options, FUNNEL_DEFAULTS));
};

SignupTracker.prototype.instaFunnelTrack = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof window.analytics === 'undefined') {
    return;
  }

  window.analytics.track('insta_funnel', _Object$assign(options, FUNNEL_DEFAULTS));
};

SignupTracker.prototype.trackSuccess = function (customEvent, isCustomEmail) {
  var dfr = $.Deferred();
  var self = this;
  var event = customEvent || null;

  this.onSuccessTrekkie();

  $.when(self.onCustomEmail(isCustomEmail), self.onSuccessGAUniversal(event), self.onSuccessOptimizely(), self.onSuccessFacebookPixel()).done(function () {
    dfr.resolve();
  });

  // A dead man's switch ensuring that the form will be submitted even if
  // analytics services are down
  window.setTimeout(function () {
    dfr.resolve();
  }, 450);

  return dfr;
};

SignupTracker.prototype.onCustomEmail = function (customEmail) {
  var dfr = $.Deferred();
  var self = this;

  if (!customEmail) {
    return dfr.resolve();
  }

  $.when(self.onCustomEmailFacebook(), self.onCustomEmailGAUniversal(), self.onCustomEmailOptimizely()).done(function () {
    dfr.resolve();
  });

  return dfr;
};

SignupTracker.prototype.onCustomEmailOptimizely = function () {
  return this._optimizely('SignedUpCustomEmail');
};

SignupTracker.prototype.onCustomEmailGAUniversal = function () {
  var event = this.config.gaEvents.customEmail;

  return this._gaUniversal(event);
};

SignupTracker.prototype.onSuccessGAUniversal = function (customEvent) {
  var event = customEvent || this.config.gaEvents.success;

  return this._gaUniversal(event);
};

SignupTracker.prototype.onSuccessOptimizely = function () {
  return this._optimizely('SignedUp');
};

SignupTracker.prototype.onSuccessTrekkie = function () {
  if (typeof window.analytics !== 'undefined') {
    window.analytics.track('signup');
  }

  this.instaFunnelTrack({
    step: 'create-your-store',
    depth: 2
  });
};

SignupTracker.prototype.onCustomEmailFacebook = function () {
  // sets up a dummy promise to wait for Facebook requests.
  // (their API doesn't provide a callback)
  var dfr = $.Deferred();

  // delay added to ensure optimzely events are sent
  window.setTimeout(function () {
    dfr.resolve();
  }, 150);

  if (typeof window.fbq !== 'undefined') {
    window.fbq('trackCustom', 'LeadCustomEmailDomain');
  }

  return dfr;
};

SignupTracker.prototype.onSuccessFacebookPixel = function () {
  // Sets up a dummy promise to wait for Facebook requests.
  // (their API doesn't provide a callback)
  var dfr = $.Deferred();

  // Delay added to ensure event is sent
  window.setTimeout(function () {
    dfr.resolve();
  }, 150);

  if (typeof window.fbq !== 'undefined') {
    window.fbq('trackCustom', 'LeadSubmit');
  }

  return dfr;
};

SignupTracker.prototype.sendGAEvent = function (status) {
  // helper function to send Google Analytics events on form behaviour
  var gaEvents = this.config.gaEvents;

  if (status in gaEvents) {
    Analytics.track(gaEvents[status].tracker);
  }
};

SignupTracker.prototype.trackError = function (field, error, val) {
  var data = field === 'shop_name' ? val : '';
  var action = _Object$keys(error).toString();

  if (typeof window.analytics !== 'undefined') {
    var errorData = {
      category: 'threefield_error',
      shop_name: data // eslint-disable-line camelcase
    };
    window.analytics.track(field + '_' + action, errorData);
  }

  Analytics.track('threefield_error', field + '_' + action, data);
};

SignupTracker.prototype.trackHiddenFields = function (fields) {
  var signupParams = HIDDEN_FIELDS.reduce(function (prev, key) {
    if (fields[key]) {
      prev[key] = fields[key];
    }

    return prev;
  }, {});

  FormsAPI.track(signupParams);
};

SignupTracker.prototype._optimizely = function (event) {
  // sets up a dummy promise to wait for Optimizely requests.
  // (their API doesn't provide a callback)
  var dfr = $.Deferred();

  // delay added to ensure optimzely events are sent
  window.setTimeout(function () {
    dfr.resolve();
  }, 150);

  // Track with Optimizely
  window.optimizely = window.optimizely || [];

  if ($.isFunction(window.optimizely.push)) {
    window.optimizely.push({
      type: 'event',
      eventName: event
    });
  }

  return dfr;
};

SignupTracker.prototype._gaUniversal = function (event) {
  // sets up a promise to wait for Google Analytics' Universal Tracking
  // callback to fire
  var dfr = $.Deferred();

  if (!$.isFunction(window._gaUTracker)) {
    return dfr.resolve();
  }

  // callback fired by analytics
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/advanced#hitCallback
  event.tracker.hitCallback = function () {
    dfr.resolve();
  };

  Analytics.track(event.tracker);

  return dfr;
};

var signupTracker = new SignupTracker();

module.exports = signupTracker;
